<template>
  <div class="national-base" :style="`padding-top:${barHeight}px`">
    <van-nav-bar class="van-bar" :title="$t('lang.commonM.k111')" left-arrow @click-left="goPrevious">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
      </template>
    </van-nav-bar>

    <img class="bg-img" src="./images/rules-bg.png" :style="{ 'margin-top': `-${barHeight + 46}px` }" />
    <div class="bg-block">
      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k230') }}</div>
        <div class="item-txt" v-if="mexActStartTime && mexActEndTime">
          {{ $t('lang.commonM.k231') }}:
          <br />
          <i style="color: #ff9524">{{ mexActStartTime }} - {{ mexActEndTime }}</i>
        </div>
        <div class="item-txt">{{ $t('lang.commonM.k251') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k233') }}</div>
        <div class="item-txt">{{ $t('lang.commonM.k248') }}</div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Balloons.png" alt="" />
            {{ $t('lang.commonM.k304') }}
          </div>
          <span>
            <i>1</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Ring.png" alt="" />
            {{ $t('lang.commonM.k211') }}
          </div>
          <span>
            <i>3</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Rose.png" alt="" />
            {{ $t('lang.commonM.k212') }}
          </div>
          <span>
            <i>5</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Kiss.png" alt="" />
            {{ $t('lang.commonM.k305') }}
          </div>
          <span>
            <i>15</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Treasure.png" alt="" />
            {{ $t('lang.commonM.k306') }}
          </div>
          <span>
            <i>50</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k238') }}</div>
        <div class="item-txt">{{ $t('lang.commonM.k249') }}</div>

        <div class="national-item" style="margin-top: 16px">
          <div class="reward-num">No.1</div>
          <div class="reward-coins">
            1000
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">No.2</div>
          <div class="reward-coins">
            600
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">No.3</div>
          <div class="reward-coins">
            300
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">No.4-10</div>
          <div class="reward-coins">
            80
            <img class="coins-icon" :src="getMatchImg('coin')" />
          </div>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k236') }}</div>
        <div class="item-txt">{{ $t('lang.commonM.k106') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k237') }}</div>
        <div class="item-txt">{{ $t('lang.commonM.k107') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfoBr } from './apidir/api.js'

export default {
  data() {
    return {
      mexActStartTime: '',
      mexActEndTime: ''
    }
  },
  methods: {
    // 获取数据
    fetchData() {
      holidayActBaseInfoBr().then((resData) => {
        if (resData.startTimestamp) {
          this.mexActStartTime = this.handleMoment(resData.startTimestamp, 'YYYY-MM-DD HH:mm:ss')
        }
        if (resData.endTimestamp) {
          this.mexActEndTime = this.handleMoment(resData.endTimestamp, 'YYYY-MM-DD HH:mm:ss')
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
img:not([src]) {
  opacity: 0;
}

.national-base {
  width: 100%;
  min-height: calc(100vh - 150px);
  background: #20a438;

  .bg-img {
    width: 100%;
  }

  .bg-block {
    position: relative;
    margin-top: -50px;
    min-height: 100vh;
    padding: 20px 10px;

    .item-block {
      width: 100%;
      padding: 16px;
      margin-bottom: 16px;
      background: #f4faf2;
      border-radius: 12px;

      .item-tit {
        line-height: 22px;
        font-family: TikTokSans;
        font-weight: 600;
        font-size: 17px;
        color: #076229;
        line-height: 22px;
      }

      .item-txt {
        width: 323px;
        line-height: 22px;
        font-family: TikTokSans;
        font-weight: 400;
        font-size: 15px;
        color: #576f60;
        margin-top: 8px;
      }

      .gift-num {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        > div {
          display: flex;
          align-items: center;
          gap: 10px;

          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 17px;
          color: #295948;
          line-height: 20px;

          img {
            width: 24px;
            height: 24px;
          }
        }
        > span {
          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 17px;
          color: #295948;
          line-height: 20px;
          text-align: right;
          i {
            font-family: 'Inter';
            font-weight: 600;
          }
        }
      }

      .national-item {
        font-family: TikTokSans;
        font-weight: 400;
        font-size: 15px;
        color: #295948;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        .reward-coins {
          display: flex;
          align-items: center;
          font-weight: bold;
          .coins-icon {
            width: 16px;
            height: 16px;
            margin-left: 4px;
          }
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'TikTokSans-Regular';
  font-weight: 600;
  color: #ffffff;
}
::v-deep .van-nav-bar__right .tit-right {
  line-height: 16px !important;
}
</style>
